__turbopack_context__.v({
  "className": "plus_jakarta_sans_bc714602-module__rJqewq__className",
  "variable": "plus_jakarta_sans_bc714602-module__rJqewq__variable",
});
